const mobileButtonSelector = '.warranty__details-button-mobile';
const desktopButtonSelector = '.warranty__details-button-desktop';
const closeSelector = '.warranty__modal-close';
const modalSelector = '.warranty__modal';
const closeCtaSelector = '.close-cta';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(mobileButtonSelector).forEach((e)=> {
        e.addEventListener('click', () => {
            const modal = e.closest('.block.warranty').querySelector(modalSelector);
            const closeButton = modal.querySelector(closeSelector);
            const closeCta = modal.querySelector(closeCtaSelector);
            modal.classList.add('-visible');
            closeButton.addEventListener('click', ()=> {
                modal.classList.remove('-visible');
            });
            closeCta?.addEventListener('click', ()=> {
                modal.classList.remove('-visible');
            });
            modal.addEventListener('click', (e)=> {
                if(e.target === modal){
                    modal.classList.remove('-visible');
                }
            });
        });
    });

    document.querySelectorAll(desktopButtonSelector).forEach((e)=> {
        let db = false;
        e.addEventListener('click', (e) => {
            if (db) return;
            e.target.closest('.block.warranty').classList.toggle('open');
            db = true;
            setTimeout(function(){
               db = false;
            }, 50);
        });
    });
});